"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "MultiSelect", {
  enumerable: true,
  get: function () {
    return _MultiSelect.MultiSelect;
  }
});
Object.defineProperty(exports, "Select", {
  enumerable: true,
  get: function () {
    return _Select.Select;
  }
});
Object.defineProperty(exports, "createFilter", {
  enumerable: true,
  get: function () {
    return _reactSelect.createFilter;
  }
});
exports.selectComponents = exports.multiSelectComponents = void 0;
var _reactSelect = require("react-select");
var _ClearIndicator = require("./components/ClearIndicator");
var _Control = require("./components/Control");
var _DropdownIndicator = require("./components/DropdownIndicator");
var _IndicatorSeparator = require("./components/IndicatorSeparator");
var _IndicatorsContainer = require("./components/IndicatorsContainer");
var _Input = require("./components/Input");
var _LoadingIndicator = require("./components/LoadingIndicator");
var _Menu = require("./components/Menu");
var _MenuList = require("./components/MenuList");
var _MenuPortal = require("./components/MenuPortal");
var _MultiSelectOption = require("./components/MultiSelectOption");
var _MultiValue = require("./components/MultiValue");
var _MultiValueContainer = require("./components/MultiValueContainer");
var _Option = require("./components/Option");
var _Placeholder = require("./components/Placeholder");
var _SingleValue = require("./components/SingleValue");
var _ValueContainer = require("./components/ValueContainer");
var _VirtualizedMenuList = require("./components/VirtualizedMenuList");
var _MultiSelect = require("./MultiSelect");
var _Select = require("./Select");
const {
  CrossIcon,
  DownChevron,
  LoadingMessage,
  NoOptionsMessage,
  SelectContainer
} = _reactSelect.components;
const sharedComponents = {
  ClearIndicator: _ClearIndicator.ClearIndicator,
  Control: _Control.Control,
  CrossIcon,
  DownChevron,
  DropdownIndicator: _DropdownIndicator.DropdownIndicator,
  IndicatorsContainer: _IndicatorsContainer.IndicatorsContainer,
  IndicatorSeparator: _IndicatorSeparator.IndicatorSeparator,
  Input: _Input.Input,
  LoadingIndicator: _LoadingIndicator.LoadingIndicator,
  LoadingMessage,
  Menu: _Menu.Menu,
  MenuList: _MenuList.MenuList,
  MenuPortal: _MenuPortal.MenuPortal,
  NoOptionsMessage,
  Placeholder: _Placeholder.Placeholder,
  SelectContainer,
  VirtualizedMenuList: _VirtualizedMenuList.VirtualizedMenuList
};
const selectComponents = {
  ...sharedComponents,
  Option: _Option.Option,
  SingleValue: _SingleValue.SingleValue,
  ValueContainer: _ValueContainer.ValueContainer
};
exports.selectComponents = selectComponents;
const multiSelectComponents = {
  ...sharedComponents,
  MultiSelectOption: _MultiSelectOption.MultiSelectOption,
  MultiValue: _MultiValue.MultiValue,
  MultiValueContainer: _MultiValueContainer.MultiValueContainer
};
exports.multiSelectComponents = multiSelectComponents;
//# sourceMappingURL=index.js.map